export default __webpack_public_path__ + "static/media/PiikApp.40628834.svg";